import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../../app/common/common.action';
import EtapasCommonPage from './etapas.common.page';
import {
  ordemSugeridaEtapas,
  atalhosEtapas,
  atalhosUtil
} from './etapas.common.util';
import {
  etapasEnum,
  etapasIndexEnum,
  statusEtapasEnum
} from '@common/util/defaultValues';
import CommonFunctions from '@util/functions.common';
import { development } from '@constants/defaultValues';
import { verificarPlainTextMudou, recuperarTextoRtfAndPlainText } from '../editor/editor.util';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar'
import WebapiCommon from '@util/webapi.common';

class EtapasCommonContainer extends Component {
  constructor (props) {
    super(props);

    this.state = {
      toogleRef: null,
      active: undefined,
      collapse: false,
      etapasAnteriores: [],
      fullscreen: false,
      isVerifyEditor: false,
      modalConfirmar: false,
      textoAtual : '',
      payload: undefined,
      fecharTela : false
    };

    window.addEventListener('keydown', this.updateAtalho.bind(this));

    this.developement = development;
  }

  updateAtalho(event) {
    if (
      event.altKey &&
      event.key !== 'Alt' &&
      event.ctrlKey &&
      event.key !== 'Ctrl' &&
      this.props.detalhes
    ) {
      this.props.actions.preencherAtalho('ctrl+alt+' + event.key);
    }
  }

  render () {
    return (
      <React.Fragment>
        <ModalConfirmar
        toggleModalConfirmar={() =>
          this.setState({
            modalConfirmar: !this.state.modalConfirmar
          })
        }
        type={'alerta'}
        showModalConfirmar={this.state.modalConfirmar}
        titulo={this.props.intl.formatMessage({ id: "dashboards.examDetail.headsUp" })}
        mensagem={this.props.intl.formatMessage({ id: "dashboards.examDetails.saved" })}
        confirmar={()=> {
          WebapiCommon.atualizarTexto(this.state.payload.laudo,
            this.state.payload.texto,
                this.state.payload.etapa,
                 this.state.payload.plainText,
                  this.state.payload.statusEtapa,
                  this.state.payload.laudoTextoId,
                  this.state.payload.medicoExecutante,
                  this.state.payload.medicoRevisor,
                  this.state.payload.headerFooter,
                  true
                  ).then(res=>{
                    this.fecharModalConfirmar();
                  })
          }}
        close = {()=> {
          this.fecharModalConfirmar();

         }}
         cancelar = {()=> {
          this.fecharModalConfirmar();
         }}

      />
        <EtapasCommonPage
          history={this.props.history}
          detalhes={this.props.detalhes}
          listagem={this.props.listagem}
          active={this.state.active}
          toggle={this.toggle.bind(this)}
          altura={'100%'}
          getNavItemClassName={this.getNavItemClassName.bind(this)}
          etapaNaoAplicavel={this.etapaNaoAplicavel.bind(this)}
          voltarParaListagemExames={this.voltarParaListagemExames.bind(this)}
          verificaEditor={this.verificaEditor.bind(this)}
          exameFinalizado={this.props.exameFinalizado}
        />
      </React.Fragment>
    );
  }

  fecharModalConfirmar(){
    const _fechar = this.props.fecharTela;
    this.setState({ modalConfirmar: false });
    this.props.actions.changeRtf(null);
    this.props.actions.preencherPlainText(undefined);
    this.props.actions.changeFecharTela(false);
    this.props.actions.preencherIdRtf(0);
    if (_fechar || !this.state.toogleRef){
      return this.props.history.goBack();
    }
    else {
      if(this.state.toogleRef !== this.state.active )
      {
        this.toggle(this.state.toogleRef);
      }
    }


  }

  toggle (active) {
    this.props.actions.preencherAtalho(undefined);
    if (active === etapasIndexEnum.ERRATA) {
      const conclusaoRealizada =
        this.getEtapa(etapasEnum.CONCLUSAO).status ===
        statusEtapasEnum.REALIZADO;
      if (!conclusaoRealizada) {
        const msg = this.props.intl.formatMessage({ id:"dashboards.examDetail.completeTheExam"});
        const tamanho = msg.length * 10 + 'px';
        this.props.actions.showAlerta('alerta', msg, 5000, tamanho);
        return;
      }
    }
    if (
      this.state.active !== active &&
      this.props.detalhes.existeNConfImpeditivaAreaTecnica
    ) {
      const msg = this.props.intl.formatMessage({ id:"dashboards.examDetail.impedingNonCompliance"});
      const tamanho = msg.length * 10 + 'px';
      this.props.actions.showAlerta('alerta', msg, 3500, tamanho);
    } else {
      this.props.actions.exameFinalizado(
        this.getEtapa(etapasEnum.CONCLUSAO).status ===
          statusEtapasEnum.REALIZADO
      );

      let etapasAnteriores = [...this.state.etapasAnteriores];
      etapasAnteriores.push(this.state.active);

      this.setState({ active: active, etapasAnteriores });
      this.props.actions.atualizarLarguraEditor('100%');
      this.props.actions.mudarEtapa(
        ordemSugeridaEtapas.find(e => e.tab === active)
      );
    }

    this.props.actions.changeFecharTela(false);
  }

  componentDidMount () {
    this.props.actions.atualizarLarguraEditor('100%');
    if (this.props.detalhes !== undefined) {
      let etapas = [...this.props.detalhes.etapas];
      let proximaEtapa = CommonFunctions.getProximaEtapaSugerida(etapas);

      if (this.props.detalhes.existeNConfImpeditivaAreaTecnica) {
        proximaEtapa = etapasIndexEnum.MATERIAL;
      }

      this.props.actions.mudarEtapa(
        ordemSugeridaEtapas.find(e => e.tab === proximaEtapa)
      );
      this.setState({
        active: proximaEtapa
      });
      this.props.actions.exameFinalizado(
        this.getEtapa(etapasEnum.CONCLUSAO).status ===
          statusEtapasEnum.REALIZADO
      );
      this.props.actions.exameEntregue(this.props.detalhes.entregue);
    }
  }

  componentDidUpdate (defaultProps) {

    if (this.props.atalho) {
      var etapa = atalhosEtapas[this.props.atalho.toLowerCase()];
      if (etapa && !this.etapaNaoAplicavel(etapa.nome)) {
        this.toggle(etapa.indice);
        this.props.actions.preencherAtalho(undefined);
      } else if (atalhosUtil[this.props.atalho.toLowerCase()]) {
        etapa = atalhosUtil[this.props.atalho.toLowerCase()];
        if (etapa.indice === etapasIndexEnum.MATERIAL) {
          this.changeFullScreen();
        }
      }

      if (etapa){
        this.props.actions.preencherAtalho(undefined);
      }
    }

    if (this.props.etapa !== defaultProps.etapa) {
      this.setState({
        active: this.props.etapa.tab
      });

    }

    if (this.props.plainTextLaudo && this.props.rtf ){
      const oldPlainText = localStorage.getItem('plaintext');

      if (oldPlainText && oldPlainText !== undefined && oldPlainText !== 'undefined'
         && (oldPlainText.replace(/(\r\n|\n|\r)/gm, "") !== this.props.plainTextLaudo.replace(/(\r\n|\n|\r)/gm, ""))
         && ((this.getEtapa(this.props.etapa.etapa.toUpperCase()).status !== statusEtapasEnum.REALIZADO))){
          this.setState({payload :{
            laudo: this.props.detalhes.laudo,
            texto: atob( this.props.rtf),
            etapa: this.props.etapa.etapa.toLowerCase(),
            plainText: this.props.plainTextLaudo,
            statusEtapa: 'P',
            laudoTextoId: this.props.editor.idRtf,
            medicoExecutante: this.props.editor.medExecutante,
            medicoRevisor: this.props.editor.medRevisor,
            headerFooter: this.props.editor.headerFooterRtf}
        });
        debugger;

        console.log('teste',(oldPlainText).replace(/(\r\n|\n|\r)/gm, ""));
        console.log('teste', this.props.plainTextLaudo.replace(/(\r\n|\n|\r)/gm, ""));

        this.setState({ modalConfirmar: true });
      }
      else
      {
        this.fecharModalConfirmar();
      }

      this.props.actions.changeRtf(null);
      this.props.actions.preencherPlainText(undefined);
    }
  }

  verificaEditor(el){
    verificarPlainTextMudou();
    this.setState({toogleRef: el})
  }

  changeFullScreen () {
    var elem = document.documentElement;

    if (elem) {
      if (this.state.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }

        this.setState({ fullscreen: false });
      } else {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
        this.setState({ fullscreen: true });
      }
    }
  }

  getNavItemClassName (etapa, tab) {
    let classBase = 'col arrow_box ';
    this.props.detalhes.etapas.find(e => {
      if (e.etapa === etapa) {
        classBase += e.status;
      }
      return false;
    });
    classBase += this.state.active === tab ? ' ativo' : '';
    return classBase;
  }

  etapaNaoAplicavel (etapa) {
    const etapaMaterial = this.getEtapa(etapasEnum.MATERIAL);

    switch (etapa) {
      case etapasEnum.MATERIAL:
        return etapaMaterial.status === statusEtapasEnum.NAO_APLICAVEL;
      case etapasEnum.MACRO:
        let naoaplicavel = etapaMaterial.status !== statusEtapasEnum.REALIZADO;
        if (naoaplicavel) {
          naoaplicavel =
            etapaMaterial.status === statusEtapasEnum.NAO_CONFORMIDADE &&
            etapaMaterial.etapaFinalizada &&
            !etapaMaterial.nConfImpeditiva
              ? false
              : naoaplicavel;
        }
        const etapaMacro = this.getEtapa(etapasEnum.MACRO);
        if (etapaMacro.status === statusEtapasEnum.NAO_APLICAVEL) {
          return true;
        }
        if (
          etapaMaterial.status === statusEtapasEnum.PENDENTE &&
          naoaplicavel
        ) {
          return false;
        }
        return (
          this.getEtapa(etapasEnum.MACRO).status ===
            statusEtapasEnum.NAO_APLICAVEL || naoaplicavel
        );
      case etapasEnum.CONGELACAO:
        const etapaCongelacao = this.getEtapa(etapasEnum.CONGELACAO);
        if (etapaCongelacao.status === statusEtapasEnum.NAO_APLICAVEL) {
          return true;
        }
        return !(
          etapaMaterial.status === statusEtapasEnum.REALIZADO ||
          etapaMaterial.status === statusEtapasEnum.PENDENTE
        );

      case etapasEnum.NOTAS:
      case etapasEnum.ERRATA:
        return false;

      default:
        if (this.developement) {
          if (this.getEtapa(etapa).status === statusEtapasEnum.NAO_APLICAVEL)
            return true;
          else return false;
        }

        if (this.getEtapa(etapa).status === statusEtapasEnum.NAO_APLICAVEL) {
          return true;
        }

        if (etapaMaterial.status !== statusEtapasEnum.REALIZADO) {
          return true;
        }

        return false;
    }
  }

  getEtapa (etapa) {
    return this.props.detalhes.etapas.find(e => e.etapa === etapa);
  }

  voltarParaListagemExames () {
    this.props.actions.atualizarDetalhes(undefined);
  }
}

const mapStateToProps = state => {
  return {
    detalhes: state.commonReducer.detalhes,
    altura: state.commonReducer.altura,
    atalho: state.commonReducer.atalho,
    etapa: state.commonReducer.etapa,
    exameFinalizado: state.commonReducer.exameFinalizado,
    rtf: state.commonReducer.rtf,
	  plainTextLaudo: state.commonReducer.plainTextLaudo,
    fecharTela : state.commonReducer.fecharTela,
    idRtf : state.commonReducer.idRtf,
    editor : state.editor
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EtapasCommonContainer);




// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/etapas.common.container.js